import { useState, useEffect } from 'react';

export function useFetch(apiFunc, params) {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		let isCanceled = false;

		const fetchData = async () => {
			try {
				setLoading(true);
				setError(null);

				const result = await apiFunc(...params);

				if (!isCanceled) {
					setData(result);
				}
			} catch (error) {
				if (!isCanceled) {
					setError({
						status: error.response?.status,
						data: error.response?.data,
						code: error.response?.data?.errorCode
					});
				}
			} finally {
				if (!isCanceled) {
					setLoading(false);
				}
			}
		};

		fetchData();

		return () => {
			isCanceled = true;
		};
	}, [apiFunc, ...params]);

	return { data, loading, error };
}